var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"ui-flag tw-relative tw-m-0 tw-mr-2 flex-fixed tw-overflow-hidden",class:{
    'tw-flex': !_vm.inline,
    'tw-inline-block': _vm.inline
  }},[_c('img',{class:("tw-absolute tw-top-0 tw-left-0 flag-small flag flag-" + (_vm.country.toLowerCase())),attrs:{"alt":_vm.country.toUpperCase(),"src":"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="}})])}
var staticRenderFns = []

export { render, staticRenderFns }